import React, { useState } from "react";
import { Card, Tab, Tabs, Button, Modal, Form, Alert } from "react-bootstrap";
import Spinner from "../generics/Spinner";

const MaintenanceSettings = ({
  machineTypes,
  machineTypesPages,
  machineTypesLoading,
  facilityTypes,
  facilityTypesPages,
  facilityTypesLoading,
  locations,
  locationsPages,
  locationsLoading,
  serviceProviders,
  serviceProvidersPages,
  serviceProvidersLoading,
  loading,
  error,
  onCreateMachineType,
  onUpdateMachineType,
  onDeleteMachineType,
  onFilterMachineTypes,
  onCreateFacilityType,
  onUpdateFacilityType,
  onDeleteFacilityType,
  onFilterFacilityTypes,
  activeTab,
  onTabChange,
  onCreateLocation,
  onUpdateLocation,
  onDeleteLocation,
  onFilterLocations,
  onCreateServiceProvider,
  onUpdateServiceProvider,
  onDeleteServiceProvider,
  onFilterServiceProviders,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [machineTypeSearch, setMachineTypeSearch] = useState("");
  const [machineTypeActiveFilter, setMachineTypeActiveFilter] = useState("");
  const [facilityTypeSearch, setFacilityTypeSearch] = useState("");
  const [facilityTypeActiveFilter, setFacilityTypeActiveFilter] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [locationActiveFilter, setLocationActiveFilter] = useState("");
  const [serviceProviderSearch, setServiceProviderSearch] = useState("");
  const [serviceProviderActiveFilter, setServiceProviderActiveFilter] = useState("");

  const openCreateModal = (type) => {
    setModalType(type);
    setEditItem(null);
    setFormData(getDefaultFormData(type));
    setShowModal(true);
  };

  const openEditModal = (type, item) => {
    setModalType(type);
    setEditItem(item);
    setFormData({ ...item });
    setShowModal(true);
  };

  const getDefaultFormData = (type) => {
    switch (type) {
      case "machineType":
        return { name: "", description: "", is_active: true };
      case "facilityType":
        return { name: "", description: "", is_active: true };
      case "location":
        return { name: "", description: "", is_active: true };
      case "serviceProvider":
        return {
          name: "",
          contact_name: "",
          phone: "",
          email: "",
          address: "",
          specialization: "",
          notes: "",
          is_active: true,
        };
      default:
        return {};
    }
  };

  const stripReadOnlyFields = (data) => {
    const { id, machines_count, facilities_count, maintenance_count, assigned_tasks_count, has_portal_access, created_at, updated_at, ...writableData } = data;
    return writableData;
  };

  const handleSubmit = () => {
    const submitData = editItem ? stripReadOnlyFields(formData) : formData;
    switch (modalType) {
      case "machineType":
        if (editItem) {
          onUpdateMachineType && onUpdateMachineType(editItem.id, submitData);
        } else {
          onCreateMachineType && onCreateMachineType(submitData);
        }
        break;
      case "facilityType":
        if (editItem) {
          onUpdateFacilityType && onUpdateFacilityType(editItem.id, submitData);
        } else {
          onCreateFacilityType && onCreateFacilityType(submitData);
        }
        break;
      case "location":
        if (editItem) {
          onUpdateLocation && onUpdateLocation(editItem.id, submitData);
        } else {
          onCreateLocation && onCreateLocation(submitData);
        }
        break;
      case "serviceProvider":
        if (editItem) {
          onUpdateServiceProvider && onUpdateServiceProvider(editItem.id, submitData);
        } else {
          onCreateServiceProvider && onCreateServiceProvider(submitData);
        }
        break;
      default:
        break;
    }
    setShowModal(false);
  };

  const handleDelete = (type, id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    switch (type) {
      case "machineType":
        onDeleteMachineType && onDeleteMachineType(id);
        break;
      case "facilityType":
        onDeleteFacilityType && onDeleteFacilityType(id);
        break;
      case "location":
        onDeleteLocation && onDeleteLocation(id);
        break;
      case "serviceProvider":
        onDeleteServiceProvider && onDeleteServiceProvider(id);
        break;
      default:
        break;
    }
  };

  if (loading && machineTypes.length === 0) {
    return <Spinner />;
  }

  const handleMachineTypeFilterChange = (field, value) => {
    const newSearch = field === "search" ? value : machineTypeSearch;
    const newActive = field === "isActive" ? value : machineTypeActiveFilter;
    if (field === "search") setMachineTypeSearch(value);
    if (field === "isActive") setMachineTypeActiveFilter(value);
    if (onFilterMachineTypes) {
      onFilterMachineTypes({
        search: newSearch || null,
        isActive: newActive === "" ? null : newActive === "true",
      });
    }
  };

  const clearMachineTypeFilters = () => {
    setMachineTypeSearch("");
    setMachineTypeActiveFilter("");
    if (onFilterMachineTypes) {
      onFilterMachineTypes({ search: null, isActive: null });
    }
  };

  const handleFacilityTypeFilterChange = (field, value) => {
    const newSearch = field === "search" ? value : facilityTypeSearch;
    const newActive = field === "isActive" ? value : facilityTypeActiveFilter;
    if (field === "search") setFacilityTypeSearch(value);
    if (field === "isActive") setFacilityTypeActiveFilter(value);
    if (onFilterFacilityTypes) {
      onFilterFacilityTypes({
        search: newSearch || null,
        isActive: newActive === "" ? null : newActive === "true",
      });
    }
  };

  const clearFacilityTypeFilters = () => {
    setFacilityTypeSearch("");
    setFacilityTypeActiveFilter("");
    if (onFilterFacilityTypes) {
      onFilterFacilityTypes({ search: null, isActive: null });
    }
  };

  const handleLocationFilterChange = (field, value) => {
    const newSearch = field === "search" ? value : locationSearch;
    const newActive = field === "isActive" ? value : locationActiveFilter;
    if (field === "search") setLocationSearch(value);
    if (field === "isActive") setLocationActiveFilter(value);
    if (onFilterLocations) {
      onFilterLocations({
        search: newSearch || null,
        isActive: newActive === "" ? null : newActive === "true",
      });
    }
  };

  const clearLocationFilters = () => {
    setLocationSearch("");
    setLocationActiveFilter("");
    if (onFilterLocations) {
      onFilterLocations({ search: null, isActive: null });
    }
  };

  const renderMachineTypesTab = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">Manage machine types for categorization</small>
        <Button variant="primary" size="sm" onClick={() => openCreateModal("machineType")}>
          <i className="fa fa-plus me-1"></i> Add Type
        </Button>
      </div>
      <div className="card mb-3">
        <div className="card-header reports-filter">
          <Form onSubmit={(e) => e.preventDefault()} className="row align-items-center mb-0">
            <div className="col-12 col-sm-5">
              <label className="col-form-label filter-label" htmlFor="machineTypeSearch">
                <i className="fa fa-search mr-05 ml-05"></i>
                Search
              </label>
              <input
                type="text"
                id="machineTypeSearch"
                className="form-control"
                placeholder="Name, description..."
                value={machineTypeSearch}
                onChange={(e) => handleMachineTypeFilterChange("search", e.target.value)}
              />
            </div>
            <div className="col-12 col-sm-3">
              <label className="col-form-label filter-label ml-05">
                Status
              </label>
              <select
                className="form-control"
                value={machineTypeActiveFilter}
                onChange={(e) => handleMachineTypeFilterChange("isActive", e.target.value)}
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div className="col-12 col-sm-2 d-flex align-items-end" style={{ paddingTop: "32px" }}>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clearMachineTypeFilters}>
                <i className="fa fa-times me-1"></i> Clear
              </button>
            </div>
          </Form>
        </div>
      </div>
      {machineTypesLoading && machineTypes.length > 0 && (
        <div className="text-center py-2">
          <i className="fa fa-spinner fa-spin me-2"></i>
          Loading...
        </div>
      )}
      {machineTypes.length === 0 && !machineTypesLoading ? (
        <div className="shipment-list--empty text-center py-4">
          <i className="fa fa-tags fa-2x mb-2 text-muted"></i>
          <p className="mb-0 text-muted">No machine types found</p>
        </div>
      ) : machineTypes.length > 0 ? (
        <>
          <table className="table table-striped table-bordered datatable mb-0" style={{ opacity: machineTypesLoading ? 0.5 : 1 }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Machines</th>
                <th>Status</th>
                <th className="text-center" style={{ width: "80px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {machineTypes.map((type) => (
                <tr key={type.id}>
                  <td><strong>{type.name}</strong></td>
                  <td><small className="text-muted">{type.description || "-"}</small></td>
                  <td>{type.machines_count || 0}</td>
                  <td>
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: type.is_active ? "#198754" : "#6c757d" }}
                    >
                      {type.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="text-center">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-1"
                      onClick={() => openEditModal("machineType", type)}
                    >
                      <i className="fa fa-pencil"></i>
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete("machineType", type.id)}
                      disabled={type.machines_count > 0}
                      title={type.machines_count > 0 ? "Cannot delete - has machines" : "Delete"}
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-muted small mt-2">
            Showing {machineTypes.length} machine type{machineTypes.length !== 1 ? "s" : ""}
          </div>
        </>
      ) : null}
    </div>
  );

  const renderFacilityTypesTab = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">Manage facility types for categorization</small>
        <Button variant="primary" size="sm" onClick={() => openCreateModal("facilityType")}>
          <i className="fa fa-plus me-1"></i> Add Type
        </Button>
      </div>
      <div className="card mb-3">
        <div className="card-header reports-filter">
          <Form onSubmit={(e) => e.preventDefault()} className="row align-items-center mb-0">
            <div className="col-12 col-sm-5">
              <label className="col-form-label filter-label" htmlFor="facilityTypeSearch">
                <i className="fa fa-search mr-05 ml-05"></i>
                Search
              </label>
              <input
                type="text"
                id="facilityTypeSearch"
                className="form-control"
                placeholder="Name, description..."
                value={facilityTypeSearch}
                onChange={(e) => handleFacilityTypeFilterChange("search", e.target.value)}
              />
            </div>
            <div className="col-12 col-sm-3">
              <label className="col-form-label filter-label ml-05">
                Status
              </label>
              <select
                className="form-control"
                value={facilityTypeActiveFilter}
                onChange={(e) => handleFacilityTypeFilterChange("isActive", e.target.value)}
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div className="col-12 col-sm-2 d-flex align-items-end" style={{ paddingTop: "32px" }}>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clearFacilityTypeFilters}>
                <i className="fa fa-times me-1"></i> Clear
              </button>
            </div>
          </Form>
        </div>
      </div>
      {facilityTypesLoading && facilityTypes.length > 0 && (
        <div className="text-center py-2">
          <i className="fa fa-spinner fa-spin me-2"></i>
          Loading...
        </div>
      )}
      {facilityTypes.length === 0 && !facilityTypesLoading ? (
        <div className="shipment-list--empty text-center py-4">
          <i className="fa fa-building fa-2x mb-2 text-muted"></i>
          <p className="mb-0 text-muted">No facility types found</p>
        </div>
      ) : facilityTypes.length > 0 ? (
        <>
          <table className="table table-striped table-bordered datatable mb-0" style={{ opacity: facilityTypesLoading ? 0.5 : 1 }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Facilities</th>
                <th>Status</th>
                <th className="text-center" style={{ width: "80px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {facilityTypes.map((type) => (
                <tr key={type.id}>
                  <td><strong>{type.name}</strong></td>
                  <td><small className="text-muted">{type.description || "-"}</small></td>
                  <td>{type.facilities_count || 0}</td>
                  <td>
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: type.is_active ? "#198754" : "#6c757d" }}
                    >
                      {type.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="text-center">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-1"
                      onClick={() => openEditModal("facilityType", type)}
                    >
                      <i className="fa fa-pencil"></i>
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete("facilityType", type.id)}
                      disabled={type.facilities_count > 0}
                      title={type.facilities_count > 0 ? "Cannot delete - has facilities" : "Delete"}
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-muted small mt-2">
            Showing {facilityTypes.length} facility type{facilityTypes.length !== 1 ? "s" : ""}
          </div>
        </>
      ) : null}
    </div>
  );

  const renderLocationsTab = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">Manage machine locations</small>
        <Button variant="primary" size="sm" onClick={() => openCreateModal("location")}>
          <i className="fa fa-plus me-1"></i> Add Location
        </Button>
      </div>
      <div className="card mb-3">
        <div className="card-header reports-filter">
          <Form onSubmit={(e) => e.preventDefault()} className="row align-items-center mb-0">
            <div className="col-12 col-sm-5">
              <label className="col-form-label filter-label" htmlFor="locationSearch">
                <i className="fa fa-search mr-05 ml-05"></i>
                Search
              </label>
              <input
                type="text"
                id="locationSearch"
                className="form-control"
                placeholder="Name, description..."
                value={locationSearch}
                onChange={(e) => handleLocationFilterChange("search", e.target.value)}
              />
            </div>
            <div className="col-12 col-sm-3">
              <label className="col-form-label filter-label ml-05">
                Status
              </label>
              <select
                className="form-control"
                value={locationActiveFilter}
                onChange={(e) => handleLocationFilterChange("isActive", e.target.value)}
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div className="col-12 col-sm-2 d-flex align-items-end" style={{ paddingTop: "32px" }}>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clearLocationFilters}>
                <i className="fa fa-times me-1"></i> Clear
              </button>
            </div>
          </Form>
        </div>
      </div>
      {locationsLoading && locations.length > 0 && (
        <div className="text-center py-2">
          <i className="fa fa-spinner fa-spin me-2"></i>
          Loading...
        </div>
      )}
      {locations.length === 0 && !locationsLoading ? (
        <div className="shipment-list--empty text-center py-4">
          <i className="fa fa-map-marker fa-2x mb-2 text-muted"></i>
          <p className="mb-0 text-muted">No locations found</p>
        </div>
      ) : locations.length > 0 ? (
        <>
          <table className="table table-striped table-bordered datatable mb-0" style={{ opacity: locationsLoading ? 0.5 : 1 }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Machines</th>
                <th>Status</th>
                <th className="text-center" style={{ width: "80px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {locations.map((loc) => (
                <tr key={loc.id}>
                  <td><strong>{loc.name}</strong></td>
                  <td><small className="text-muted">{loc.description || "-"}</small></td>
                  <td>{loc.machines_count || 0}</td>
                  <td>
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: loc.is_active ? "#198754" : "#6c757d" }}
                    >
                      {loc.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="text-center">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-1"
                      onClick={() => openEditModal("location", loc)}
                    >
                      <i className="fa fa-pencil"></i>
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete("location", loc.id)}
                      disabled={loc.machines_count > 0}
                      title={loc.machines_count > 0 ? "Cannot delete - has machines" : "Delete"}
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-muted small mt-2">
            Showing {locations.length} location{locations.length !== 1 ? "s" : ""}
          </div>
        </>
      ) : null}
    </div>
  );

  const handleServiceProviderFilterChange = (field, value) => {
    const newSearch = field === "search" ? value : serviceProviderSearch;
    const newActive = field === "isActive" ? value : serviceProviderActiveFilter;
    if (field === "search") setServiceProviderSearch(value);
    if (field === "isActive") setServiceProviderActiveFilter(value);
    if (onFilterServiceProviders) {
      onFilterServiceProviders({
        search: newSearch || null,
        isActive: newActive === "" ? null : newActive === "true",
      });
    }
  };

  const clearServiceProviderFilters = () => {
    setServiceProviderSearch("");
    setServiceProviderActiveFilter("");
    if (onFilterServiceProviders) {
      onFilterServiceProviders({ search: null, isActive: null });
    }
  };

  const renderServiceProvidersTab = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">Manage external service providers</small>
        <Button variant="primary" size="sm" onClick={() => openCreateModal("serviceProvider")}>
          <i className="fa fa-plus me-1"></i> Add Provider
        </Button>
      </div>
      <div className="card mb-3">
        <div className="card-header reports-filter">
          <Form onSubmit={(e) => e.preventDefault()} className="row align-items-center mb-0">
            <div className="col-12 col-sm-5">
              <label className="col-form-label filter-label" htmlFor="serviceProviderSearch">
                <i className="fa fa-search mr-05 ml-05"></i>
                Search
              </label>
              <input
                type="text"
                id="serviceProviderSearch"
                className="form-control"
                placeholder="Name, contact, email, specialization..."
                value={serviceProviderSearch}
                onChange={(e) => handleServiceProviderFilterChange("search", e.target.value)}
              />
            </div>
            <div className="col-12 col-sm-3">
              <label className="col-form-label filter-label ml-05">
                Status
              </label>
              <select
                className="form-control"
                value={serviceProviderActiveFilter}
                onChange={(e) => handleServiceProviderFilterChange("isActive", e.target.value)}
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div className="col-12 col-sm-2 d-flex align-items-end" style={{ paddingTop: "32px" }}>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clearServiceProviderFilters}>
                <i className="fa fa-times me-1"></i> Clear
              </button>
            </div>
          </Form>
        </div>
      </div>
      {serviceProvidersLoading && serviceProviders.length > 0 && (
        <div className="text-center py-2">
          <i className="fa fa-spinner fa-spin me-2"></i>
          Loading...
        </div>
      )}
      {serviceProviders.length === 0 && !serviceProvidersLoading ? (
        <div className="shipment-list--empty text-center py-4">
          <i className="fa fa-users fa-2x mb-2 text-muted"></i>
          <p className="mb-0 text-muted">No service providers found</p>
        </div>
      ) : serviceProviders.length > 0 ? (
        <>
          <table className="table table-striped table-bordered datatable mb-0" style={{ opacity: serviceProvidersLoading ? 0.5 : 1 }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Contact</th>
                <th>Specialization</th>
                <th>Records</th>
                <th>Active Tasks</th>
                <th>Portal</th>
                <th>Status</th>
                <th className="text-center" style={{ width: "80px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {serviceProviders.map((provider) => (
                <tr key={provider.id}>
                  <td>
                    <strong>{provider.name}</strong>
                    {provider.email && (
                      <small className="d-block text-muted">{provider.email}</small>
                    )}
                  </td>
                  <td>
                    {provider.contact_name || "-"}
                    {provider.phone && (
                      <small className="d-block text-muted">{provider.phone}</small>
                    )}
                  </td>
                  <td>
                    <small className="text-truncate d-inline-block" style={{ maxWidth: "150px" }}>
                      {provider.specialization || "-"}
                    </small>
                  </td>
                  <td>{provider.maintenance_count || 0}</td>
                  <td>{provider.assigned_tasks_count || 0}</td>
                  <td>
                    {provider.has_portal_access ? (
                      <span className="badge badge-pill" style={{ backgroundColor: "#0d6efd" }}>
                        <i className="fa fa-check me-1"></i>Yes
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: provider.is_active ? "#198754" : "#6c757d" }}
                    >
                      {provider.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="text-center">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-1"
                      onClick={() => openEditModal("serviceProvider", provider)}
                    >
                      <i className="fa fa-pencil"></i>
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete("serviceProvider", provider.id)}
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-muted small mt-2">
            Showing {serviceProviders.length} provider{serviceProviders.length !== 1 ? "s" : ""}
          </div>
        </>
      ) : null}
    </div>
  );

  const renderModalContent = () => {
    switch (modalType) {
      case "machineType":
      case "facilityType":
      case "location":
        return (
          <>
            <Form.Group className="mb-3">
              <Form.Label className="small">Name *</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                value={formData.name || ""}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">Description</Form.Label>
              <Form.Control
                size="sm"
                as="textarea"
                rows={2}
                value={formData.description || ""}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Active"
                checked={formData.is_active !== false}
                onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              />
            </Form.Group>
          </>
        );
      case "serviceProvider":
        return (
          <>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Company Name *</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                value={formData.name || ""}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Contact Name</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                value={formData.contact_name || ""}
                onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Phone</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                value={formData.phone || ""}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Email</Form.Label>
              <Form.Control
                size="sm"
                type="email"
                value={formData.email || ""}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Address</Form.Label>
              <Form.Control
                size="sm"
                as="textarea"
                rows={2}
                value={formData.address || ""}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Specialization</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                value={formData.specialization || ""}
                onChange={(e) => setFormData({ ...formData, specialization: e.target.value })}
                placeholder="e.g., HVAC, refrigeration, electrical"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-1">Notes</Form.Label>
              <Form.Control
                size="sm"
                as="textarea"
                rows={2}
                value={formData.notes || ""}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Active"
                checked={formData.is_active !== false}
                onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              />
            </Form.Group>
          </>
        );
      default:
        return null;
    }
  };

  const getModalTitle = () => {
    const action = editItem ? "Edit" : "Add";
    switch (modalType) {
      case "machineType":
        return `${action} Machine Type`;
      case "facilityType":
        return `${action} Facility Type`;
      case "location":
        return `${action} Location`;
      case "serviceProvider":
        return `${action} Service Provider`;
      default:
        return "";
    }
  };

  return (
    <div className="maintenance-settings">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">
          <i className="fa fa-cog me-2"></i>
          Maintenance Settings
        </h4>
      </div>

      {error && (
        <Alert variant="danger" className="py-2 mb-3">
          <i className="fa fa-exclamation-circle me-2"></i>
          {typeof error === 'string' ? error : error?.detail || error?.message || (Array.isArray(error) ? error[0] : JSON.stringify(error?.name || "An error occurred"))}
        </Alert>
      )}

      <Card>
        <Card.Header className="reports-filter">
          <i className="fa fa-sliders me-2"></i>
          Configuration
        </Card.Header>
        <Card.Body className="p-0">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => onTabChange && onTabChange(k)}
            className="px-3 pt-2"
          >
            <Tab eventKey="machineTypes" title={<><i className="fa fa-tags me-1"></i> Machine Types</>}>
              <div className="p-3">
                {renderMachineTypesTab()}
              </div>
            </Tab>
            <Tab eventKey="facilityTypes" title={<><i className="fa fa-building me-1"></i> Facility Types</>}>
              <div className="p-3">
                {renderFacilityTypesTab()}
              </div>
            </Tab>
            <Tab eventKey="locations" title={<><i className="fa fa-map-marker me-1"></i> Locations</>}>
              <div className="p-3">
                {renderLocationsTab()}
              </div>
            </Tab>
            <Tab eventKey="serviceProviders" title={<><i className="fa fa-users me-1"></i> Providers</>}>
              <div className="p-3">
                {renderServiceProvidersTab()}
              </div>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="modal-logut" animation={false}>
        <Card>
          <Card.Header className="reports-filter">
            {getModalTitle()}
          </Card.Header>
          <Card.Body>
            <Form>{renderModalContent()}</Form>
          </Card.Body>
          <Card.Footer className="d-flex justify-content-end gap-2">
            <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={handleSubmit}
              disabled={!formData.name}
            >
              <i className="fa fa-save me-1"></i>
              {editItem ? "Update" : "Create"}
            </Button>
          </Card.Footer>
        </Card>
      </Modal>
    </div>
  );
};

export default MaintenanceSettings;
